// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Component
import Colours from '../styles/colours';
import MText from './Common/MText';

const Marker = ({ logo = '', stampName }) => (
  <div
    className="position-relative justify-content-center"
    style={{
      height: '36px',
      width:  '36px',
    }}
  >
    <div className="d-flex justify-content-center" style={{ height: '100%' }}>
      <img
        // eslint-disable-next-line global-require
        src={require('../assets/images/brown-marker.png')}
        className="position-absolute"
        alt={stampName}
        style={{ width: '36px' }}
      />
      <img
        src={logo}
        alt={stampName}
        className="rounded-circle position-absolute"
        style={{ width: '30px', height: '30px', top: '3px' }}
      />
    </div>
    <MText
      className="text-center"
      style={{
        fontSize:        '13px',
        marginTop:       '8px',
        width:           '52px',
        overflow:        'hidden',
        position:        'fixed',
        left:            '50%',
        transform:       'translate(-50%)',
        display:         '-webkit-box',
        WebkitLineClamp: 2,
        lineClamp:       2,
        WebkitBoxOrient: 'vertical',
      }}
      colour={Colours.Brown}
      text={stampName}
    />
  </div>
);

Marker.propTypes = {
  // eslint-disable-next-line react/require-default-props
  logo:      PropTypes.string,
  stampName: PropTypes.string.isRequired,
};

export default Marker;
